import { THREE_LETTER_EU_COUNTRY_CODES } from "@faire/web--source/common/consts/THREE_LETTER_EU_COUNTRY_CODES";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

import { InstantAnswerContext } from "../../../types";
import { countryToISO } from "../../../utils/countryToISO";

// @ts-prune-ignore-next
export const isEUCountry = (country: string) => {
  const countryIso = countryToISO(country) as keyof typeof ISO3166Alpha3;
  return Object.keys(THREE_LETTER_EU_COUNTRY_CODES).includes(
    countryIso as (keyof typeof THREE_LETTER_EU_COUNTRY_CODES)[number]
  );
};

// Check if the order is shipping internationally
export const shipInternational = (context: InstantAnswerContext): boolean => {
  const shipFromCountry = context.shippingContext?.ship_from_address?.country;
  const shipToCountry = context.shippingContext?.ship_to_address?.country;

  if (!shipFromCountry || !shipToCountry) {
    return false;
  }

  const fromEU = isEUCountry(shipFromCountry);
  const toEU = isEUCountry(shipToCountry);

  if (fromEU && toEU) {
    return false;
  }

  return shipFromCountry !== shipToCountry;
};
